/**
 * This is a little implementation detail that helps us avoid circular imports.
 * **Please do not extend this class.**
 */
export class TensorBase {}
